import Loader from "react-loader-spinner";

function LoaderComp(){
    return (
        <Loader
            type="ThreeDots"
            color="#3a7cb3"
            height={150}
            width={150}
        />
    );
}

export default LoaderComp;